export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/bundle.a1bdbcc4a728a7ced5cf.worker.js");
}
